module.exports = __webpack_public_path__ + "static/the-fitness-depot-e0d526342989e370737f117ae2f461d9.png";